import React from "react";
import "./simple-loading.pure.css";
import GovoLoading from "../../../assets/logos/govo_loading.gif";

const SimpleLoading = (props) => {
  return (
    <div className="huella-animation-container">
      <img
        alt="Animacion Huella"
        className="huella-animation-settings"
        src={GovoLoading}
      />
    </div>
  );
};

export { SimpleLoading as default };
